import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../modal/withModal';
import Button from '../../../../../Button';
import Alert from '../../../../../Alert';
import FormGroup from '../../../../../FormGroup';
import { isValidEmail } from '../../../../../../../util/email';

export const COLLAGE_DESIGNER_EMAIL_MODAL = 'MODAL/COLLAGE_DESIGNER_EMAIL';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const CollageDesignerEmailModal = ({ onSubmit, onClose }) => {
  const [emailAddress, setEmailAddress] = useState('');
  const [error, setError] = useState('');

  const onFormSubmit = () => {
    if (!isValidEmail(emailAddress)) {
      setError('Please enter a valid email address.');
      return;
    }

    onSubmit?.(emailAddress);
    onClose?.();
  };

  return (
    <Fragment>
      <div>
        <h3 className="text-center">One last step!</h3>
        <p className="text-light text-center">
          Please add your email address below and we&apos;ll email your hi-res
          collage download to you!
        </p>
        <FormGroup
          type="text"
          id="email-address"
          label="Email Address"
          name="emailAddress"
          value={emailAddress}
          onChange={({ target }) => setEmailAddress(target.value)}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              event.stopPropagation();
              event.preventDefault();
              onFormSubmit();
            }
          }}
          required
        />
        {error && (
          <Alert
            dismissible
            type="danger"
            className="mb-2"
            onDismiss={() => setError('')}
          >
            {error}
          </Alert>
        )}
        <div className="mx-4">
          <Button btnBlock onClick={() => onFormSubmit()}>
            Submit
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

CollageDesignerEmailModal.propTypes = propTypes;

export default withModal(CollageDesignerEmailModal, {
  name: COLLAGE_DESIGNER_EMAIL_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  dismissible: false,
  closeOnOverlayClick: false,
  className: 'collage-designer-email-modal',
  overlayClassName: 'collage-designer-email-modal-overlay',
});
